export const Props = () => ({
  //Использовать ли цветовой мод для градиента
  colorMode: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'secondary'].includes(value)
  },
});